import { Injectable, Injector } from '@angular/core';
import { BrowserStorageService } from '../../shared/services/storage.service';
import {
    CitaProgramadaNoOtorgadaGetListQuery,
    CitasServiceProxy
} from '../../shared/service-proxies/service-proxies';
import { BehaviorSubject, Observable, finalize } from 'rxjs';
import { DialogCustomService } from '../../shared/services/dialog.custom.service';
import {
    CitasNoOtorgadasComponent
} from '../_components/consultas/citasnootorgadas/citasnootorgadas.component';
import { AppComponent } from '../app.component';
import { LocalizationService } from '../../shared/services/localization.service';

@Injectable({ providedIn: 'root' })
export class CitasNoOtorgadasService {

    public citasNoOtorgadas: Observable<boolean>;
    private citasNoOtorgadasSubject: BehaviorSubject<boolean>;

    private totalCitas = 0;
    private primeraVez = true;

    constructor(injector: Injector,
        private browserStorageService: BrowserStorageService,
        private service: CitasServiceProxy,
        private dialogService: DialogCustomService,
        private localization: LocalizationService) {

        this.citasNoOtorgadasSubject = new BehaviorSubject<boolean>(false);
        this.citasNoOtorgadas = this.citasNoOtorgadasSubject.asObservable();

        this.iniciarMonitorCitasNoOtorgadas();
    }

    iniciarMonitorCitasNoOtorgadas(): void {
        const self = this;

        self.getCitasNoOtorgadas();

        // Este monitoreo debe ejecutarse cada 5 minutos (300,000 milisegundos)
        setInterval(function () {
            self.getCitasNoOtorgadas();
        }, 300000);
    }


    getCitasNoOtorgadas(): void {
        const self = this;

        // Este método buscará una cita no otorgada..
        // Si hay al menos una para el día de hoy, entonces mostrará la ventana modal con todas
        // las citas no otorgadas disponibles
        const req = new CitaProgramadaNoOtorgadaGetListQuery();
        req.pageNumber = 1;
        req.pageSize = 1;

        self.service.getCitasProgramadasNoOtorgadasList(req)
            .pipe(finalize(() => {

            }))
            .subscribe(data => {

                if (data.totalCount > 0 && self.primeraVez) {
                    self.mostrarCitasNoOtorgadas();
                }

                self.citasNoOtorgadasSubject.next(data.totalCount > 0 && data.totalCount !== self.totalCitas);
                self.primeraVez = false;
                self.totalCitas = data.totalCount; // Se guarda este valor para hacer la siguiente comparación
            });
    }

    mostrarCitasNoOtorgadas(): void {
        const self = this;

        const ref = self.dialogService.open(CitasNoOtorgadasComponent, {
            styleClass: 'd-sm d-md-70 d-lg-60 d-xl-60',
            header: self.localization.l('Procesos.SesionesHD.Citas.NoOtorgadas'),
            showHeader: true,
            dismissableMask: false,
            data: {
            }
        });
    }
}
